import React, { useEffect, useState } from 'react';
import { Link } from 'wouter';
//import globalStore from '../store/global';
import ContenedorAnimacion from './ContenedorAnimacion';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YoutubeIcon from '@mui/icons-material/YouTube';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';

//import HomeIcon from '@mui/icons-material/Home';
import logografico from './../assets/images/logo_vidaplus_transparente_200x60.png'
//import isologo from './../assets/images/isotipo.png'
import EnviarMensaje from '../functions/EnviarMensaje';
import VentanaModalFormulario from './VentanaModalFormulario';

const Contacto: React.FC<{ id: string }> = ({ id }) => {

    const [enviar, setEnviar] = useState(false);
    const [errorApeyNom, setErrorApeyNom] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorCelular, setErrorCelular] = useState(false);
    const [errorAsunto, setErrorAsunto] = useState(false);
    const [errorMensaje, setErrorMensaje] = useState(false);

    const [enviandoMensaje, setEnviandoMensaje] = useState(false);
    const [mensajeEnviado, setMensajeEnviado] = useState('');

    const [apeynom, setApeynom] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [asunto, setAsunto] = useState('');
    const [mensaje, setMensaje] = useState('');

    const handleApeYNomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setApeynom(e.target.value.toUpperCase());
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleCelularChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const regex = /^[0-9\b]+$/; // Expresión regular para permitir solo números
        if (value === '' || regex.test(value)) {
            if (value.length <= 10) {
                setCelular(value);
            }
        };
    };

    const handleAsuntoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAsunto(e.target.value);
    };

    const handleMensajeChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMensaje(e.target.value);
    };

    const handleApeYNomBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const apeynomLocal = e.target.value;
        if (apeynomLocal.trim().length < 5 && apeynomLocal.trim().length !== 0) {
            setErrorApeyNom(true);
        } else {
            setErrorApeyNom(false);
        }
        setApeynom(apeynomLocal);
    };

    const handleEmailBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const emailLocal = e.target.value;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailLocal.trim().length === 0) {
            setErrorEmail(false);
        } else {
            if (regex.test(emailLocal)) {
                setErrorEmail(false);
            } else {
            setErrorEmail(true);
            }
        }
        setEmail(emailLocal);
    };

    const handleCelularBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const celularLocal = e.target.value;
        if (celularLocal.trim().length < 10 && celularLocal.trim().length !== 0) {
            setErrorCelular(true);
        } else {
            setErrorCelular(false);
        }
        setCelular(celularLocal);
    };

    const handleAsuntoBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const asuntoLocal = e.target.value;
        if (asuntoLocal.trim().length < 5 && asuntoLocal.trim().length !== 0) {
            setErrorAsunto(true);
        } else {
            setErrorAsunto(false);
        }
        setAsunto(asuntoLocal);
    };

    const handleMensajeBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const mensajeLocal = e.target.value;
        if (mensajeLocal.trim().length < 5 && mensajeLocal.trim().length !== 0) {
            setErrorMensaje(true);
        } else {
            setErrorMensaje(false);
        }
        setMensaje(mensajeLocal);
    };

    const reestablecerFormulario = () => {
        setEnviar(false);
        setApeynom('');
        setEmail('');
        setCelular('');
        setAsunto('');
        setMensaje('');
        setErrorApeyNom(false);
        setErrorEmail(false);
        setErrorCelular(false);
        setErrorAsunto(false);
        setErrorMensaje(false);
    };

    const enviarMensaje = async () => {
        setEnviandoMensaje(true);
        try {
            const resultado = await EnviarMensaje(apeynom, email, celular, asunto, mensaje);
            setEnviandoMensaje(false);
            setMensajeEnviado(resultado.mensaje_enviado);
            reestablecerFormulario();
        } catch (error) {
            console.log("Error:", error);
            setEnviandoMensaje(false);
            setMensajeEnviado('NO');
        }
    };

    useEffect(() => {
        if (enviandoMensaje) {
          enviarMensaje();
        }
      }, [enviandoMensaje]);

    useEffect(() => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (apeynom.trim().length >= 5
            && email.trim().length >= 5
            && regex.test(email)
            && celular.trim().length === 10
            && asunto.trim().length >= 5
            && mensaje.trim().length >= 5) {
                setEnviar(true);
        } else {
            setEnviar(false);
        }
    }, [apeynom, email, celular, asunto, mensaje]);

    return (
        <section id={id} className="bg-stone-100 h-screen pt-[100px] mb-4">
            {/*Formulario de contacto */}
            <div className="flex flex-col px-4 max-w-screen-md mx-auto mb-4">
                <ContenedorAnimacion animation='slideInLeft' duration={800} delay={1} className="">
                    <div>
                        <h2 className="text-center font-metropolis mb-4 mt-4 text-4xl xxs:text-2xl xs:text-3xl tracking-tight font-regular text-gray-900 ">¿Tenés&nbsp;Dudas?</h2>
                    </div>
                </ContenedorAnimacion>
                <ContenedorAnimacion animation='slideInRight' duration={800} delay={1} className="">
                    <div className="flex flex-col items-center justify-center">
                        <p className="font-light text-center text-gray-700 text-lg xxs:text-sm mb-2">¿Tenés alguna pregunta adicional o necesitas más información?</p>
                        <div className="flex flex-row flex-wrap w-full items-center justify-center mb-5 md:flex-wrap">
                            <div className="flex flex-col justify-center items-center">
                                <Link className="vp-btn-azul-sm shadow-md shadow-vp-gris mb-3" to="/PFs"><LiveHelpIcon fontSize={"small"} className="mr-1" />Preguntas Frecuentes</Link>
                                <a href="https://wa.me/5493415779225"  className="vp-btn-verde-sm shadow-md shadow-vp-gris" target="_blank" rel="noreferrer">
                                    <WhatsAppIcon fontSize={"small"} className="mb-1 mr-1" />Chateá con Nosotros
                                </a>
                            </div>
                        </div>
                        <p className="font-light text-center text-gray-700 text-lg xxs:text-sm">Si no encontrás la respuesta a tu pregunta, completá el formulario de contacto</p>
                        <p className="font-light mb-8 text-center text-gray-700 text-lg xxs:text-sm">y nos comunicaremos con vos lo antes posible.</p>
                    </div>
                </ContenedorAnimacion>
                <div>
                    {!enviandoMensaje && mensajeEnviado === 'SI' &&
                    (
                        <div className="flex flex-col justify-center items-center mb-2">
                            <div className="flex flex-row justify-center items-center">
                                <h3 className="font-metropolis text-lg font-bold text-vp-verde">Mensaje enviado correctamente</h3>
                                <HighlightOffIcon className="text-vp-verde ml-2 cursor-pointer" onClick={() => setMensajeEnviado('')} />
                            </div>
                        </div>
                    )}
                    {!enviandoMensaje && mensajeEnviado === 'NO' &&
                    (
                        <div className="flex flex-col justify-center items-center mb-2">
                            <div className="flex flex-row justify-center items-center">
                                <h3 className="font-metropolis text-lg font-bold text-red-700">Error al enviar el mensaje</h3>
                                <HighlightOffIcon className="text-red-700 ml-2 cursor-pointer" onClick={() => setMensajeEnviado('')} />
                            </div>
                        </div>
                    )}
                </div>                
                <ContenedorAnimacion animation='zoomIn' duration={800} delay={1} className="">
                    <div>
                        <VentanaModalFormulario isOpen={enviandoMensaje} />
                        <form action="#" className="space-y-4">
                            <div className="flex flex-col justify-start items-start">
                                <div className="flex flex-row justify-start items-start"></div><label htmlFor="apeynom" className="block mb-2 text-sm font-medium text-gray-900 ">Tu Apellido y Nombres</label>
                                <input type="text" id="apeynom" value={apeynom} className="bg-gray-50 border-2 border-vp-azulclaro text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:border-vp-azul focus:shadow-md focus:shadow-stone-600 outline-none transition" placeholder="APELLIDO, NOMBRES" required onChange={handleApeYNomChange} onBlur={handleApeYNomBlur} />
                                <p className={`text-red-700 text-sm font-myriad-pro font-regular mt-2 ml-2 ${errorApeyNom ? 'flex':'hidden'}`}>{errorApeyNom ? 'El campo es obligatorio' : ''}</p>
                            </div>
                            <div className="flex flex-col justify-start items-start">
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 ">Tu correo electrónico</label>
                                <input type="email" id="email" value={email} className="bg-gray-50 border-2 border-vp-azulclaro text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:border-vp-azul focus:shadow-md focus:shadow-stone-600 outline-none transition" placeholder="Correo Electrónico" required onChange={handleEmailChange} onBlur={handleEmailBlur}/>
                                <p className={`text-red-700 text-sm font-myriad-pro font-regular mt-2 ml-2 ${errorEmail ? 'flex':'hidden'}`}>{errorEmail ? 'El campo es obligatorio y debe ser una dirección de email válida.' : ''}</p>
                            </div>
                            <div className="flex flex-col justify-start items-start">
                                <label htmlFor="celular" className="block mb-2 text-sm font-medium text-gray-900 ">Tu nro. de teléfono celular (sin 0 y sin 15)</label>
                                <input type="text" id="celular" value={celular} className="bg-gray-50 border-2 border-vp-azulclaro text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:border-vp-azul focus:shadow-md focus:shadow-stone-600 outline-none transition" placeholder="Nro. de Celular" required maxLength={10} onChange={handleCelularChange} onBlur={handleCelularBlur}/>
                                <p className={`text-red-700 text-sm font-myriad-pro font-regular mt-2 ml-2 ${errorCelular ? 'flex':'hidden'}`}>{errorCelular ? 'El campo es obligatorio y debe tener 10 dígitos.' : ''}</p>
                            </div>
                            <div className="flex flex-col justify-start items-start">
                                <label htmlFor="asunto" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Asunto</label>
                                <input type="text" id="asunto" value={asunto} className="bg-gray-50 border-2 border-vp-azulclaro text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:border-vp-azul focus:shadow-md focus:shadow-stone-600 outline-none transition" placeholder="Decinos cómo podemos ayudarte" required onChange={handleAsuntoChange} onBlur={handleAsuntoBlur}/>
                                <p className={`text-red-700 text-sm font-myriad-pro font-regular mt-2 ml-2 ${errorAsunto ? 'flex':'hidden'}`}>{errorAsunto ? 'El campo es obligatorio.' : ''}</p>
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="mensaje" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Mensaje</label>
                                <textarea id="mensaje" rows={3} value={mensaje} className="bg-gray-50 border-2 border-vp-azulclaro text-gray-900 text-sm rounded-lg  block w-full p-2.5 focus:border-vp-azul focus:shadow-md focus:shadow-stone-600 outline-none transition" placeholder="Escribe tu consulta aquí..." required onChange={handleMensajeChange} onBlur={handleMensajeBlur}></textarea>
                                <p className={`text-red-700 text-sm font-myriad-pro font-regular mt-2 ml-2 ${errorMensaje ? 'flex':'hidden'}`}>{errorMensaje ? 'El campo es obligatorio.' : ''}</p>
                            </div>
                            <div className="flex flex-row flex-grow justify-start items-center gap-3 xxs:flex-col xxs:mx-4">
                                <button type="button" className={`vp-btn-azul w-50 xxs:w-full disabled:border-gray-400 disabled:bg-gray-400 disabled:hover:bg-gray-400 disabled:hover:border-gray-400 outline-none`} disabled={!enviar} onClick={enviarMensaje}>Enviar mensaje</button>
                                <button type="reset" className="vp-btn-verde w-50 xxs:w-full outline-none" onClick={reestablecerFormulario}>Limpiar</button>
                            </div>
                        </form>
                    </div>
                </ContenedorAnimacion>
            </div>
            {/* Footer */}
            <div>
                <div className="flex flex-col justify-center items-center bg-white pt-2 border-t border-stone-300 flex-grow">
                    <div className="flex flex-col mx-6 justify-evenly items-center w-full md:flex-row">
                        {/* Logo grande */}
                        <div className="flex-col flex justify-center items-center group">
                            <img src={logografico} className="max-h-[40px] min-w-[140px] group-hover:drop-shadow-lg group-hover:shadow-vp-gris group-hover:scale-110 transition" alt="VidaPlus Logo" />
                        </div>
                        {/* Email */}
                        <div className="flex mt-2 flex-col justify-center items-center md:mt-0">
                            <div className="flex flex-row justify-center items-center group">
                                <a href="https://wa.me/5493415779225" target="_blank" rel="noreferrer" className="flex flex-row">
                                    <div className="flex flex-col justify-center items-center rounded-full p-1 group-hover:shadow-md group-hover:shadow-vp-gris group-hover:scale-110 transition">
                                        <MailOutlineIcon  className="text-vp-gris" />
                                    </div>
                                    <div className="flex flex-col justify-center items-center">
                                        <p className="font-myriad-pro text-vp-gris font-regular">contacto@vidaplus.com.ar</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* Whatsapp */}
                        <div className="flex flex-col justify-center items-center">
                            <div className="flex flex-row justify-center items-center group">
                                <a href="https://wa.me/5493415779225" target="_blank" rel="noreferrer" className="flex flex-row">
                                    <div className="flex flex-col justify-center items-center rounded-full p-1 group-hover:shadow-md group-hover:shadow-vp-gris group-hover:scale-110 transition">
                                        <WhatsAppIcon  className="text-vp-gris" />
                                    </div>
                                    <div className="flex flex-col justify-center items-center">
                                        <p className="font-myriad-pro text-vp-gris font-regular">+54 9 341 577-9225</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {/* Seguinos en nuestras redes */}
                        <div className="flex flex-col justify-center items-center my-2 md:my-0">
                            <div className="flex flex-row justify-center items-center rounded-full ">
                                <div className="hidden flex-col justify-center items-center md:flex">
                                    <h4 className="font-myriad-pro text-vp-gris font-regular mr-3">Seguinos en nuestras redes</h4>
                                </div>
                                <div className="flex flex-col justify-center items-center group mr-2">
                                    <a href="https://www.instagram.com/vidaplus.ar?igsh=Zm15anBhc3k0dzBi" target="_blank" rel="noreferrer">
                                        <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                            <InstagramIcon className="text-vp-gris" />
                                        </div>
                                    </a>
                                </div>
                                <div className="flex flex-col justify-center items-center group mr-2">
                                    <a href="https://www.facebook.com/share/15hzijgbsK/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                                        <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                            <FacebookIcon className="text-vp-gris" />
                                        </div>
                                    </a>
                                </div>
                                <div className="flex flex-col justify-center items-center group">
                                    <a href="https://www.youtube.com/@vidaplus-salud" target="_blank" rel="noreferrer">
                                        <div className="text-center rounded-full p-2 bg-white shadow-lg shadow-vp-gris group-hover:scale-110 transition">
                                            <YoutubeIcon className="text-vp-gris" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Todos los derechos reservados */}
                    <div className="flex flex-col sm:flex-row justify-start items-center mt-1">
                        <h4 className="font-myriad-pro text-vp-gris font-regular ">Todos los derechos reservados.</h4>
                    </div> 
                    {/* Sitio desarrollado por SecureNetwork S.A. */}
                    <div className="flex flex-col sm:flex-row justify-center flex-wrap items-center mt-1">
                        <div className="flex flex-row justify-center items-center xxs:flex-col">
                            <h4 className="font-myriad-pro text-vp-gris font-regular mt-3 mb-2 mr-2">Sitio desarrollado por: </h4>
                            <a href="https://www.securenetwork.com.ar" target="_blank" rel="noreferrer" className="font-myriad-pro text-vp-gris font-bold underline">SecureNetwork S.A.</a>
                        </div>
                    </div> 
                </div>
            </div>
        </section>  
    );
};

export default Contacto;
